import React, { useRef } from 'react';
import { Link, LinkProps } from '@app/router';
import { PopoverTrigger } from '@stockx/ui';

const DropdownLink = ({ children, to, onClick, ...props }: LinkProps) => {
  const ref = useRef<HTMLAnchorElement>(null);

  return (
    <PopoverTrigger>
      <Link ref={ref} to={to} onClick={onClick} {...props}>
        {children}
      </Link>
    </PopoverTrigger>
  );
};

export default DropdownLink;
